<div *ngIf="!testResult" class="testResult">
  Generating report ..
</div>
<div *ngIf="testResult" class="testResult">
   <img src='../../assets/helena-ppk-horiz.svg' width='400'>
  <table>
    <thead>
      <tr>
        <th colspan="6" class="printReportTitle">Tankmix Information</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Date Tested:</th>
        <td>{{ testResult.dateOfTest | date }}</td>
        <th>Tankmix Result:</th>
        <td><fa-icon [icon]="testResult.result | tankmixResultTransform" size="2x"></fa-icon></td>
        <th>Water Volume</th>
        <td>{{ convertedWaterRate( testResult.waterRate) | number:'1.1-1' }} {{unitsChoice}}</td>
     
      </tr>
    </tbody>
  </table>
  <table>
    <thead>
      <tr>
        <th>Order</th>
        <th>Product Name</th>
        <th>Country Of Origin</th>
        <th>{{unitsChoice}}</th>
        <th>Active Ingredients</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ingredient of testResult.ingredients; let i = index">
        <td>{{ i + 1 }}</td>
        <td>
          <ng-container *ngIf="ingredient.products.length" >{{ ingredient.products[0] }}</ng-container>
          <ng-container *ngIf="!ingredient.products.length"  >{{ ingredient.name }}</ng-container>
          </td>
        <td>{{ ingredient.country}}</td>
        <td><span *ngIf="ingredient.form!='P'">{{ convertedAppRate(ingredient.rate) | number:'1.2-2'}}</span> <span *ngIf="ingredient.form=='P'">{{convertPowderUnits(ingredient.rate)}}</span> </td>
        <td>{{ ingredient.activeIngredients }}</td>
      </tr>
    </tbody>
  </table>
  <p>
    Physical tank mix tests check that the products are physically suitable for application with a conventional sprayer. The tests do not
    check for any adverse crop phytotoxicity or for the biological efficacy of the individual components when applied in a tank mix. Yara
    gives no warranty and accepts no liability in respect of physical mixability
  </p>
 <button class='hideForPrint btn-success' onclick='window.print()'><fa-icon [icon]="faPrint" size="2x"></fa-icon></button>
</div>
